<template>
<DashBoardLayout>
    <div>
        <h3>Developer Contact Page ....</h3>
    </div>
</DashBoardLayout>
</template>
<script>
import DashBoardLayout from '../layouts/DashboardLayout.vue'

export default {
  components:{DashBoardLayout},
}
</script>

